import { render, staticRenderFns } from "./JcrCom.vue?vue&type=template&id=4bedbca0&scoped=true"
import script from "./JcrCom.vue?vue&type=script&lang=js"
export * from "./JcrCom.vue?vue&type=script&lang=js"
import style0 from "./JcrCom.vue?vue&type=style&index=0&id=4bedbca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bedbca0",
  null
  
)

export default component.exports